import 'angular-scroll';

export default 'duScroll';
